module.exports = __webpack_public_path__ + "img/cs-loader.6cc976da.png";